<template>
    <others>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Resource</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-8">
                        <div class="col-span-8 sm:col-span-4">
                            <breeze-label :required="true" :value="'Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''" />
                        </div>
                        <div class="col-span-8 sm:col-span-4">
                            <breeze-label :value="'Due Date'"/>
                            <breeze-input type="date" v-model="form.due_date" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.due_date:''" />
                        </div>
                        <div class="col-span-8">
                            <breeze-label :value="'Description'"/>
                            <breeze-input v-model="form.description" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.description:''" />
                        </div>
                        <div class="col-span-8 sm:col-span-2">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model:checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <div class="flex items-center gap-4">
                        <breeze-button :disabled="form.processing">Update</breeze-button>
                        <button-link :href="route('others.resource.list')">Back</button-link>
                    </div>
                    <exception />
                </form>
            </div>
        </div>
    </others>
</template>

<script>
import Others from '@/Pages/Others/Others'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import ButtonLink from '@/Components/ButtonLink'
import Loading from '@/Components/Loading'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Others,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        ButtonLink,
        Loading,
        Exception,
    },
    props: ['resource'],
    data() {
        return {
            form: useForm({
                title: this.resource.title,
                description: this.resource.description,
                due_date: this.resource.due_date,
                status: this.resource.status,
            }),
        }
    },
    methods: {
        submitForm() {
            this.form.put(route('others.resource.update', this.resource.id));
        },
    },
}
</script>
